var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.57178C6.79086 5.57178 5 7.36264 5 9.57178C5 11.7809 6.79086 13.5718 9 13.5718C11.2091 13.5718 13 11.7809 13 9.57178C13 8.60493 12.6573 7.71838 12.0859 7.02654V8.33887H11.0859V5.33887H14.0859V6.33887H12.8143C13.5535 7.21026 14 8.33901 14 9.57178C14 12.3332 11.7614 14.5718 9 14.5718C6.23858 14.5718 4 12.3332 4 9.57178C4 6.81035 6.23858 4.57178 9 4.57178V5.57178Z",
    fill: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBlack);
export default __webpack_public_path__ + "static/media/refresh-black.a85bcdfe915037ef25ecdd77af77e355.svg";
export { ForwardRef as ReactComponent };